import { motion } from "framer-motion";

const PHASES = [
  {
    n: "1",
    title: "Comunicazione Preventiva (GSE)",
    desc: "Accesso tramite SPID/CIE all'Area Clienti GSE. Inserimento dei dati (Allegato V per il software). Generazione ricevuta entro 10 giorni.",
  },
  {
    n: "2",
    title: "Conferma & Acconto",
    desc: "Entro 30 giorni dalla ricevuta, invio della conferma con attestazione di versamento di un acconto minimo del 20% del costo.",
  },
  {
    n: "3",
    title: "Interconnessione & Ammortamento",
    desc: "Completamento dell'investimento, interconnessione tecnica ai sistemi aziendali e invio della comunicazione integrativa.",
  },
];

export default function PercorsoOperativo({ dark = false }) {
  return (
    <section className={`${dark ? "bg-bg-dark text-white" : "bg-white"} py-16 md:py-20`} data-testid="percorso-operativo">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className={`text-[10px] font-display tracking-[0.3em] uppercase ${dark ? "text-brand" : "text-brand-dark"}`}>
            Il percorso operativo
          </div>
          <h2 className={`mt-3 font-display text-4xl sm:text-5xl ${dark ? "text-white" : "text-ink"}`}>
            Accesso al <span className="text-brand">Portale GSE</span>
          </h2>
          <p className={`mt-4 text-sm ${dark ? "text-white/60" : "text-ink-muted"}`}>
            Le tre fasi della pratica di iperammortamento seguite dallo Studio.
          </p>
        </div>

        <div className="mt-14 relative">
          <div className={`hidden md:block absolute top-[46px] left-[10%] right-[10%] h-0.5 ${dark ? "bg-white/15" : "bg-line"}`} />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
            {PHASES.map((p, i) => (
              <motion.div
                key={p.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex flex-col items-center text-center"
                data-testid={`fase-${p.n}`}
              >
                <div className="relative w-24 h-24 mb-6 flex items-center justify-center">
                  <div className="absolute inset-0 bg-brand rotate-45 rounded-md shadow-brand-glow" />
                  <div className={`absolute -right-1 -bottom-1 w-24 h-24 border-2 border-brand-dark rotate-45 rounded-md`} />
                  <span className="relative font-display text-4xl text-white z-10">{p.n}</span>
                </div>
                <h3 className={`font-display text-lg tracking-wide ${dark ? "text-white" : "text-ink"}`}>{p.title}</h3>
                <p className={`mt-3 text-sm max-w-xs leading-relaxed ${dark ? "text-white/60" : "text-ink-muted"}`}>{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
